import { render, staticRenderFns } from "./ConsentSignature.vue?vue&type=template&id=e8ea9106&scoped=true"
import script from "./ConsentSignature.vue?vue&type=script&lang=js"
export * from "./ConsentSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ea9106",
  null
  
)

export default component.exports